import { createContext } from 'react';
import { IErrorNotification } from '../commons/interfaces/apiError.interface';

interface APIErrorContextType {
  error: IErrorNotification | null;
  addError: (message: string, status: string) => void;
  removeError: () => void;
  showError: (error: Error) => void;
  showMessage: (messagee: string) => void;
}

const APIErrorContext = createContext<APIErrorContextType>(null!);

export default APIErrorContext;
